import { useTheme as useEmotionTheme } from "@emotion/react";
import type { Theme } from "@mos-cat/ds-theme";
import { createHook } from "reakit-system";
import type { BoxHTMLProps } from "reakit";
export let useTheme = createHook<{ theme: Theme }, BoxHTMLProps>({
  keys: ["theme"],
  useOptions(options) {
    if (options.theme) return options;
    return { ...options, theme: useEmotionTheme() };
  },
});
